<template>
    <el-dropdown split-button class="translate-btn" :class="{ 'has-selection': selectedType }" @click="handleClick" @command="handleCommand">
        <i class="translate-icon" />{{ translateText }}
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0" :class="{ 'selected-item': selectedType === '0' }">
                <i v-if="selectedType === '0'" class="el-icon-check selected-icon"></i>
                {{ $i18n.t("zhiji.common.TranSmartApi") }}
            </el-dropdown-item>
            <el-dropdown-item command="2" :class="{ 'selected-item': selectedType === '2' }">
                <i v-if="selectedType === '2'" class="el-icon-check selected-icon"></i>
                {{ $i18n.t("zhiji.common.GoogleApi") }}
            </el-dropdown-item>
            <el-dropdown-item command="1" :class="{ 'selected-item': selectedType === '1' }">
                <i v-if="selectedType === '1'" class="el-icon-check selected-icon"></i>
                {{ $i18n.t("zhiji.common.TencentCloudAPI") }}
            </el-dropdown-item>
            <el-dropdown-item command="3" :class="{ 'selected-item': selectedType === '3' }">
                <i v-if="selectedType === '3'" class="el-icon-check selected-icon"></i>
                {{ $i18n.t("zhiji.common.TencentYuanAPI") }}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: "TranslateDropdown",
    props: ["translateText", "selectedType"],
    methods: {
        handleClick() {
            // 只有选中了翻译类型才能点击翻译
            if (this.selectedType) {
                this.$emit("click", this.selectedType);
            }
        },
        handleCommand(type) {
            this.$emit("click", type);
        }
    }
}
</script>

<style lang="less" scoped>
.translate-btn {
    .translate-icon {
        display: inline-block;
        vertical-align: text-bottom;
        margin-right: 5px;
        width: 16px;
        height: 16px;
        background: url("/zhiji/images/translate-normal-icon.png");
    }
    ::v-deep .el-button-group {
        .el-button:first-child {
            &:hover .translate-icon {
                background: url("/zhiji/images/translate-hover-icon.png");
            }
        }
        .el-button:last-child {
            width: 30px;
            min-width: 0px;
        }
    }
    &.has-selection {
        ::v-deep .el-button-group {
            .el-button:first-child {
                background-color: rgba(217, 235, 246, 0.7) !important;
                border-color: rgba(217, 235, 246, 0.7) !important;
                color: #55cdfe !important;
                
                .translate-icon {
                    background: url("/zhiji/images/translate-hover-icon.png");
                }
                
                &:hover {
                    background-color: rgba(217, 235, 246, 0.9) !important;
                    border-color: rgba(217, 235, 246, 0.9) !important;
                }
            }
            
            .el-button:last-child {
                background-color: rgba(217, 235, 246, 0.7) !important;
                border-color: rgba(217, 235, 246, 0.7) !important;
                color: #55cdfe !important;
                
                &:hover {
                    background-color: rgba(217, 235, 246, 0.9) !important;
                    border-color: rgba(217, 235, 246, 0.9) !important;
                }
            }
        }
    }
}

::v-deep .selected-item {
    background-color: rgba(217, 235, 246, 0.7) ;
    color: #55cdfe ;
    .selected-icon {
        margin-right: 8px;
    }
}
</style>